/* Collection grid sort: navigates to the same collection/tag path with a real ?sort_by= value. */
(function () {
  if (window.SixFtCollectionSort) return;
  window.SixFtCollectionSort = { ready: true };

  document.addEventListener('change', function (e) {
    var select = e.target.closest && e.target.closest('[data-cg-sort]');
    if (!select) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    url.searchParams.delete('page');
    url.hash = 'collection-grid';
    window.location.href = url.toString();
  });
})();
